import * as React from "react";
function findPathParent(obj, arr) {
  if (!obj)
    return;
  arr.push(obj.type);
  const children = obj.props?.children;
  if (obj.type === "path" && !children) {
    return arr.pop();
  } else if (typeof children === "object") {
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i++) {
        const result = findPathParent(children[i], arr);
        if (result) {
          break;
        }
      }
    } else {
      findPathParent(children, arr);
    }
  } else {
    arr.pop();
  }
}
function addNewStyle(newStyle) {
  let styleElement = document.getElementById("styles_js");
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.id = "styles_js";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  styleElement.appendChild(document.createTextNode(newStyle));
}
function changePathStyle(props, arr, id) {
  if (!props)
    return;
  const str = arr.join(" ");
  const root = arr[0];
  const others = arr.slice(1);
  if (props.color) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props.color + "}");
  }
  if (props["data-hovercolor"]) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovercolor"] + "}");
  }
  if (props["data-activecolor"]) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activecolor"] + "}");
  }
  if (Array.isArray(props["data-twotonecolor"])) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-twotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-twotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-hovertwotonecolor"])) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovertwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-hovertwotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-activetwotonecolor"])) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activetwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-activetwotonecolor"][1] + "}");
  }
  if (props.width) {
    addNewStyle(root + "#" + id + "{width: " + props.width + "}");
  }
  if (props.height) {
    addNewStyle(root + "#" + id + "{height: " + props.height + "}");
  }
}
const isArrayContainsElement = (arr1, arr2) => {
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.includes(arr2[i])) {
      return true;
    }
  }
  return false;
};
const OPTIONS = ["color", "data-activecolor", "data-hovercolor", "data-twotonecolor", "data-hovertwotonecolor", "data-activetwotonecolor", "width", "height"];
const SvgCopy = (props) => {
  const isSetOptions = isArrayContainsElement(Object.keys(props), OPTIONS);
  const svg = /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", id: "copy_svg_plugin_95976", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.9375 2.7375C5.9375 2.84796 6.02704 2.9375 6.1375 2.9375H12.8125V11.6125C12.8125 11.723 12.902 11.8125 13.0125 11.8125H13.8625C13.973 11.8125 14.0625 11.723 14.0625 11.6125V2.1875C14.0625 1.91136 13.8386 1.6875 13.5625 1.6875H6.1375C6.02704 1.6875 5.9375 1.77704 5.9375 1.8875V2.7375ZM3.1875 5.5625V13.0625H10.1875V5.5625H3.1875ZM2.4375 14.3125C2.16136 14.3125 1.9375 14.0886 1.9375 13.8125V4.8125C1.9375 4.53636 2.16136 4.3125 2.4375 4.3125H10.9375C11.2136 4.3125 11.4375 4.53636 11.4375 4.8125V13.8125C11.4375 14.0886 11.2136 14.3125 10.9375 14.3125H2.4375Z" }));
  if (isSetOptions) {
    const parents = [];
    findPathParent(svg, parents);
    const id = svg.props.id;
    changePathStyle(props, parents, id);
  }
  return svg;
};
export default SvgCopy;
